<div class="loading {loadingClass}" style={loadingStyle}>

    <div class="loading__disc-left-container">

        <div class="loading__disc-left" style={loadingDiscStyle}></div>

    </div>

    <div class="loading__disc-right-container">

        <div class="loading__disc-right" style={loadingDiscStyle}></div>

    </div>

</div>

<style>
    .loading {
        border-radius: 100%;
        position: relative;
        overflow: hidden;
    }

    .loading__disc-left-container, .loading__disc-right-container {
        position: absolute;
        width: 50%;
        height: 100%;
        top: 0;
        left: 0;
        overflow: hidden;
    }

    .loading__disc-right-container {
        left: inherit;
        right: 0;
    }

    .loading__disc-left, .loading__disc-right {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        content: '';
        display: block;
        background-color: var(--warning);
        transform: rotate(180deg);
        transform-origin: 100% 50%;
    }

    .loading__disc-left, .loading__disc-right {
        animation-timing-function: linear;
        animation-duration: 1s;
        animation-iteration-count: 1;
        animation-delay: 0;
    }

    .loading__disc-right {
        transform-origin: 0 50%;
        animation-name: discRight;
    }

    .loading--playing-odd .loading__disc-left {
        animation-name: discLeftOdd;
    }    

    .loading--playing-odd .loading__disc-right {
        animation-name: discRightOdd;
    }

    .loading--playing-even .loading__disc-left {
        animation-name: discLeftEven;
    }    

    .loading--playing-even .loading__disc-right {
        animation-name: discRightEven;
    }

    @keyframes discLeftOdd {
        0% {
            transform: rotate(0);
        }

        50% {
            transform: rotate(0);
        }

        100% {
            transform: rotate(180deg);
        }
    }

    @keyframes discRightOdd {
        0% {
            transform: rotate(0);
        }

        50% {
            transform: rotate(180deg);
        }

        100% {
            transform: rotate(180deg);
        }
    }

    @keyframes discLeftEven {
        0% {
            transform: rotate(0);
        }

        50% {
            transform: rotate(0);
        }

        100% {
            transform: rotate(180deg);
        }
    }

    @keyframes discRightEven {
        0% {
            transform: rotate(0);
        }

        50% {
            transform: rotate(180deg);
        }

        100% {
            transform: rotate(180deg);
        }
    }
</style>

<script>

    export default {
        computed: {
            loadingClass: ({ playing, switcharoo }) => {
                let classes = []

                if (playing && !switcharoo) classes.push('loading--playing-even')
                
                if (playing && switcharoo) classes.push('loading--playing-odd')

                return classes.filter(Boolean).join(' ')
            },
            loadingStyle: ({ diameter }) => {
                let styles = []

                styles.push(`width: ${diameter};`)
                styles.push(`height: ${diameter};`)

                return styles.filter(Boolean).join(' ')
            },
            loadingDiscStyle: ({ interval }) => {
                let styles = []

                styles.push(`animation-duration: ${interval}ms;`)

                return styles.filter(Boolean).join(' ')
            }
        },
        data() {
            return {
                diameter: '1rem',
                interval: 5000,
                playing: false,
                switcharoo: false,
            }
        }
    }

</script>